// @ts-nocheck
import React, { useState, useEffect } from "react";

import { useLocation } from "react-router-dom";
import { useAuth } from "@/containers/Auth/AuthContext";
import LoadingProgress from "@/components/LoadingProgress";
import { externalAPI } from "@/utils/api";
import { DATA_URLS } from "@/urls";

import SuperAdminMenuItems from "./SuperAdminMenuItems";
import MenuItems from "./MenuItems";

const MainNavigation = (props) => {
  const { enableSupportSection } = props;
  const location = useLocation();
  const { selectedMembership, company } = useAuth();

  const [openKeys, setOpenKeys] = useState<any>(undefined);
  const [customerHasManagedServices, setCustomerHasManagedServices] =
    useState<any>(undefined);
  const [customerHasNetsgMobile, setCustomerHasNetsgMobile] =
    useState<any>(undefined);

  const getKeyParts = (key) => {
    if (key === "/") return [];
    return key.split("/").filter((p) => p !== "");
  };

  const onOpenChange = (currentlyOpenKeys) => {
    setOpenKeys(currentlyOpenKeys);
  };

  const onMenuItemClick = ({ key }) => {
    const keyParts = getKeyParts(key);

    setOpenKeys((openKeys) => {
      if (openKeys) {
        if (keyParts.length === 1) {
          return openKeys.filter((k) => {
            return k === `/${keyParts[0]}/`;
          });
        } else {
          return openKeys.filter((k) => {
            return (
              k === `/${keyParts[0]}/` ||
              k === `/${keyParts[0]}/${keyParts[1]}/`
            );
          });
        }
      }
      return openKeys;
    });
  };

  const checkIfCustomerHasManagedServices = () => {
    externalAPI
      .get(DATA_URLS.external.managedServices.hasManagedServices.buildPath())
      .then((response) => {
        setCustomerHasManagedServices(response.data.has_managed_services);
      })
      .catch(() => {
        setCustomerHasManagedServices(false);
      });
  };

  const checkIfCustomerHasNetsgMobile = () => {
    externalAPI
      .get(DATA_URLS.external.netsgMobile.services.hasNetsgMobile.buildPath())
      .then((response) => {
        setCustomerHasNetsgMobile(response.data.has_netsg_mobile);
      })
      .catch(() => {
        setCustomerHasNetsgMobile(false);
      });
  };

  const optionalMenuProps = {};

  useEffect(() => {
    if (
      selectedMembership &&
      (selectedMembership.groupCodename === "ADMIN" ||
        selectedMembership.groupCodename === "USER" ||
        selectedMembership.groupCodename === "GUEST")
    ) {
      checkIfCustomerHasManagedServices();
      checkIfCustomerHasNetsgMobile();
    }
  }, [selectedMembership, selectedMembership.groupCodename]);

  // Derived straight from the current path (no state/effect): React Compiler
  // memoises this, and computing during render avoids the setState-in-effect
  // cascade the previous useEffect caused.
  const pathNameParts = getKeyParts(location.pathname);
  let selectedKeys;
  let defaultOpenKeys = [];

  switch (pathNameParts.length) {
    case 0:
      selectedKeys = ["/"];
      break;
    case 1:
      defaultOpenKeys = [`/${pathNameParts[0]}/`];
      selectedKeys = defaultOpenKeys;
      break;
    case 2:
      defaultOpenKeys = [`/${pathNameParts[0]}/`];
      selectedKeys = [
        `/${pathNameParts[0]}/`,
        `/${pathNameParts[0]}/${pathNameParts[1]}/`,
      ];
      break;
    default:
      defaultOpenKeys = [
        `/${pathNameParts[0]}/`,
        `/${pathNameParts[0]}/${pathNameParts[1]}/`,
      ];
      selectedKeys = [
        `/${pathNameParts[0]}/`,
        `/${pathNameParts[0]}/${pathNameParts[1]}/`,
        `/${pathNameParts[0]}/${pathNameParts[1]}/${pathNameParts[2]}/`,
      ];
  }

  if (openKeys === undefined) {
    optionalMenuProps.openKeys = defaultOpenKeys;
  } else {
    optionalMenuProps.openKeys = openKeys;
  }

  if (selectedMembership.groupCodename === "SUPERADMIN") {
    return (
      <SuperAdminMenuItems
        defaultOpenKeys={defaultOpenKeys}
        defaultSelectedKeys={selectedKeys}
        selectedKeys={selectedKeys}
        onOpenChange={onOpenChange}
        onMenuItemClick={onMenuItemClick}
        optionalMenuProps={optionalMenuProps}
      />
    );
  }

  if (
    (customerHasManagedServices === undefined ||
      customerHasNetsgMobile === undefined) &&
    (selectedMembership.groupCodename === "ADMIN" ||
      selectedMembership.groupCodename === "USER" ||
      selectedMembership.groupCodename === "GUEST")
  ) {
    return <LoadingProgress />;
  }

  if (
    (selectedMembership.groupCodename === "ADMIN" ||
      selectedMembership.groupCodename === "USER" ||
      selectedMembership.groupCodename === "GUEST") &&
    company.type === "PARTNER"
  ) {
    return (
      <MenuItems
        defaultOpenKeys={defaultOpenKeys}
        defaultSelectedKeys={selectedKeys}
        selectedKeys={selectedKeys}
        onOpenChange={onOpenChange}
        onMenuItemClick={onMenuItemClick}
        optionalMenuProps={optionalMenuProps}
        enableManagedServicesSection={customerHasManagedServices}
        enableNetsgMobileSection={customerHasNetsgMobile}
      />
    );
  }
  if (
    (selectedMembership.groupCodename === "ADMIN" ||
      selectedMembership.groupCodename === "USER" ||
      selectedMembership.groupCodename === "GUEST") &&
    company.type === "CLIENT"
  ) {
    return (
      <MenuItems
        defaultOpenKeys={defaultOpenKeys}
        defaultSelectedKeys={selectedKeys}
        selectedKeys={selectedKeys}
        enableSupportSection={enableSupportSection}
        onOpenChange={onOpenChange}
        onMenuItemClick={onMenuItemClick}
        optionalMenuProps={optionalMenuProps}
        enableManagedServicesSection={customerHasManagedServices}
        enableNetsgMobileSection={customerHasNetsgMobile}
      />
    );
  }
  if (selectedMembership.groupCodename === "NO_ACCESS") {
    return <div />;
  }

  return <LoadingProgress />;
};

export default MainNavigation;
